<template>
    <validate-form ref="form" tag="div">
        <portal to="buttons">
            <b-button variant="outline-secondary" type="reset" @click="getItem" class="mx-5 my-5">
                Annuller
            </b-button>

            <b-button @click="saveItem" variant="primary" class="mx-5 my-5">
                {{ editing ? "Gem ændringer" : "Opret ordre" }}
            </b-button>
        </portal>
        <b-form>

            <b-row>
                <b-col cols="12" lg="6" xl="5">
                    <b-card class="customer-info">
                        <template #header>
                            <b-card-title>Kundeoplysninger</b-card-title>
                            <div class="heading-elements">
                                <button type="button" v-b-modal.addressModal class="btn btn-sm btn-outline-dark px-9">
                                    <feather-icon icon="Edit2Icon" />
                                </button>
                            </div>
                        </template>
                        <b-row>
                            <b-col cols="12" md="6" class="mb-10">
                                <h5>Faktureringsadresse</h5>

                                <b-row>
                                    <b-col cols="6" md="6">
                                        <FieldGroup label="Firma" v-if="item.billingAddress.company">{{item.billingAddress.company}}</FieldGroup>
                                    </b-col>
                                    <b-col cols="6" md="6">
                                        <FieldGroup label="CVR" v-if="item.billingAddress.vatNumber">{{item.billingAddress.vatNumber}}</FieldGroup>
                                    </b-col>

                                    <b-col cols="6" md="6">
                                        <FieldGroup label="Fornavn">{{item.billingAddress.firstName}}</FieldGroup>
                                    </b-col>
                                    <b-col cols="6" md="6">
                                        <FieldGroup label="Efternavn" v-if="item.billingAddress.lastName">{{item.billingAddress.lastName}}</FieldGroup>
                                    </b-col>

                                    <b-col cols="12">
                                        <FieldGroup label="Adresse">
                                            <p>{{item.billingAddress.address1}}</p>
                                            <p v-if="item.billingAddress.address2">{{item.billingAddress.address2}}</p>
                                            <p>{{item.billingAddress.zipCode}} {{item.billingAddress.city}}</p>
                                        </FieldGroup>
                                    </b-col>

                                    <b-col cols="12">
                                        <FieldGroup label="Land">{{item.billingAddress.country}}</FieldGroup>
                                    </b-col>

                                    <b-col cols="6" md="8">
                                        <FieldGroup label="E-mail">{{item.billingAddress.email}}</FieldGroup>
                                    </b-col>
                                    <b-col cols="6" md="4">
                                        <FieldGroup label="Telefon">{{item.billingAddress.phone}}</FieldGroup>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="12" md="6">
                                <h5>Leveringsadresse</h5>

                                <b-row>
                                    <b-col cols="6" md="6">
                                        <FieldGroup label="Firma" v-if="item.shippingAddress.company">{{item.shippingAddress.company}}</FieldGroup>
                                    </b-col>
                                    <b-col cols="6" md="6">
                                        <FieldGroup label="CVR" v-if="item.shippingAddress.vatNumber">{{item.shippingAddress.vatNumber}}</FieldGroup>
                                    </b-col>

                                    <b-col cols="6" md="6">
                                        <FieldGroup label="Fornavn">{{item.shippingAddress.firstName}}</FieldGroup>
                                    </b-col>
                                    <b-col cols="6" md="6">
                                        <FieldGroup label="Efternavn" v-if="item.shippingAddress.lastName">{{item.shippingAddress.lastName}}</FieldGroup>
                                    </b-col>


                                    <b-col cols="12">
                                        <FieldGroup label="Adresse">
                                            <p>{{item.shippingAddress.address1}}</p>
                                            <p v-if="item.shippingAddress.address2">{{item.shippingAddress.address2}}</p>
                                            <p>{{item.shippingAddress.zipCode}} {{item.shippingAddress.city}}</p>
                                        </FieldGroup>
                                    </b-col>

                                    <b-col cols="12">
                                        <FieldGroup label="Land">{{item.shippingAddress.country}}</FieldGroup>
                                    </b-col>

                                    <b-col cols="6" md="8">
                                        <FieldGroup label="E-mail" v-if="item.shippingAddress.email">{{item.shippingAddress.email}}</FieldGroup>
                                    </b-col>
                                    <b-col cols="6" md="4">
                                        <FieldGroup label="Telefon" v-if="item.shippingAddress.phone">{{item.shippingAddress.phone}}</FieldGroup>
                                    </b-col>
                                </b-row>

                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>


                <b-col cols="12" lg="6" xl="7">
                    <b-row>
                        <b-col cols="12" lg="12" xl="4">
                            <b-card>
                                <FieldGroup label="Ordredato">
                                    {{$moment(item.createDate).format("DD-MM-YYYY HH:mm")}}
                                </FieldGroup>

                                <!--<FormGroup label="Ordrestatus" rules="">
                                    <template #input="{state}">
                                        <b-form-select v-model="item.orderStatus" :options="$store.state.orderStatus" />
                                    </template>
                                </FormGroup>-->

                                <FieldGroup label="Ordrestatus" class="mt-15">
                                    <div class="alert alert-primary">
                                        <div class="alert-body">
                                            {{$store.state.orderStatus.find(x => x.value == item.orderStatus).text}}
                                        </div>
                                    </div>
                                </FieldGroup>

                                <FieldGroup label="Leveringsmetode">
                                    {{item.deliveryMethod}}
                                </FieldGroup>

                                <FieldGroup label="Betalingsmetode">
                                    {{item.paymentMethod}}
                                </FieldGroup>

                                <!--<div>
                                    <b-button type="button" variant="outline-success" size="sm" class="py-10">
                                        Send faktura
                                    </b-button>

                                    <small class="float-right d-inline-block mt-8">Sendt: <strong>{{$moment().format("DD/MM-YY HH:mm")}}</strong></small>
                                </div>-->

                            </b-card>
                        </b-col>
                        <b-col cols="12" lg="12" xl="8">
                            <b-card title="Betaling" v-if="editing">

                                <div class="row">
                                    <b-col cols="12" md="4">
                                        <FieldGroup label="Levering">
                                            {{$numeral(item.shippingTotal).format("0.00")}} DKK
                                        </FieldGroup>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <FieldGroup label="Autoriseret beløb">
                                            {{$numeral(item.authorizedAmount).format("0.00")}} DKK
                                        </FieldGroup>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <FieldGroup label="Total">
                                            <strong>{{$numeral(item.orderTotal).format("0.00")}} DKK</strong>
                                        </FieldGroup>
                                    </b-col>
                                </div>

                                <div class="text-center mt-10">
                                    <b-button type="button" :to="'/api/orders/' + id + '/print'" target="_blank" variant="outline-primary" size="sm" class="py-10 mx-10 my-10">
                                        <feather-icon icon="PrinterIcon" />
                                        Pakkeseddel
                                    </b-button>

                                    <b-button type="button" variant="outline-warning" size="sm" class="py-10 mx-10 my-10">
                                        <feather-icon icon="PrinterIcon" />
                                        Print label
                                    </b-button>

                                    <b-button type="button" variant="outline-success" size="sm" class="py-10 mx-10 my-10">
                                        <feather-icon icon="CreditCardIcon" />
                                        Gennemfør ordre
                                    </b-button>

                                    <b-button type="button" variant="outline-danger" size="sm" class="py-10 mx-10 my-10">
                                        <feather-icon icon="XIcon" />
                                        Annuller ordre
                                    </b-button>
                                </div>


                            </b-card>
                        </b-col>
                    </b-row>

                </b-col>

                <b-col cols="12" lg="6">
                    <b-card title="Kunde kommentar">
                        {{item.customerComment}}
                    </b-card>
                </b-col>

                <b-col cols="12" lg="6">
                    <b-card title="Intern kommentar">
                        <b-textarea v-model="item.orderComment" type="textare" />
                    </b-card>
                </b-col>

                <b-col cols="12">
                    <b-card>
                        <table class="table b-table table-striped table-none">
                            <thead>
                                <tr>
                                    <th>Produkt</th>
                                    <th>Antal</th>
                                    <th>Pris</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(line, key) in item.orderLines" :key="key">
                                    <td>
                                        <p class="m-0">{{line.product}}</p>
                                        <small>{{line.variant}}</small>
                                    </td>
                                    <td>{{line.quantity}}</td>
                                    <td>
                                        {{$numeral(line.price).format("0.00")}}
                                        <small class="d-block" v-if="$numeral(line.discount).value() > 0">
                                            <s class="text-danger">{{$numeral(line.discount).add($numeral(line.price).value()).format("0.00") }}</s>
                                        </small>
                                    </td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card>
                </b-col>


            </b-row>


            <AddressModal :item="item"></AddressModal>

        </b-form>
    </validate-form>
</template>

<script>
    import Toast from '@/components/_toast.vue'
    import AddressModal from './_addressModal.vue'

    export default {
        components: { AddressModal },
        data: () => ({
            item: {
                id: null,
                orderStatus: 99,
                billingAddress: {
                    firstName: "Stefan",
                    lastName: "Bohlin",
                    address1: "Anelystparken 45D",
                    address2: null,
                    zipCode: "8381",
                    city: "Tilst",
                    country: "Danmark",
                },
                shippingAddress: {
                    firstName: "Stefan",
                    lastName: "Bohlin",
                    address1: "Anelystparken 45D",
                    address2: null,
                    zipCode: "8381",
                    city: "Tilst",
                    country: "Danmark",
                },
                sameShippingAddress: true,


                vat: 0.25,
                orderLines: [],
            },


        }),
        computed: {
            id() {
                return this.$route.params.id
            },
            editing() {
                return this.id != "create"
            }
        },
        created() {
            if (this.editing) {
                this.getItem()
            } else {
                this.$store.dispatch("app/UPDATE_PAGETITLE", "Opret ordre")
            }
        },
        mounted() { },
        methods: {
            getItem() {
                if (this.editing) {
                    this.$http.get("/api/orders/" + this.id).then(x => {
                        this.item = x.data

                        this.$store.dispatch("app/UPDATE_PAGETITLE", x.data.orderNumber)
                    })
                } else {
                    this.$router.push("/orders")
                }
            },
            addAddress() {
                this.item.addresses.push({

                })
            },
            saveItem() {
                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.$http.post("/api/orders/save", this.item).then(x => {

                            this.$toast({
                                component: Toast,
                                props: {
                                    title: x.data.result,
                                    icon: 'CheckCircleIcon',
                                    variant: 'success',
                                },
                            })

                            if (x.data.data) {
                                this.$router.replace({ name: "order", params: { id: x.data.data } })
                            }

                            this.getItem()
                        })
                    }
                })
            },
            editCustomer() {

            }
        },
    }
</script>

<style scoped lang="scss" src="./order.scss"></style>